var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeniAIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28714_730)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4737 32C6.24105 32 2 36.2528 2 41.5C2 46.7472 6.24105 51 11.4737 51C14.5716 51 17.3253 49.5085 19.0526 47.2C14.4516 43.7325 11.4737 38.2162 11.4737 32Z",
    fill: "#F34D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9999 35.1667C25.9999 23.9915 35.0663 14.9 46.2105 14.9H49.3684V13H30.421C19.9557 13 11.4736 21.5057 11.4736 32H20.9473V41.5C20.9473 43.6375 20.2431 45.6135 19.0526 47.2C22.2199 49.5845 26.1547 51 30.421 51C31.4126 51 32.3852 50.924 33.3357 50.7752C28.8578 47.0543 25.9999 41.4398 25.9999 35.1667Z",
    fill: "#F37021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9473 32H11.4736C11.4736 38.2162 14.4515 43.7325 19.0526 47.2C20.2431 45.6135 20.9473 43.6375 20.9473 41.5V32Z",
    fill: "#F35F21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3682 30.7335H61.9997V19.3335H56.6313H49.3682V30.7335Z",
    fill: "#F3A521"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4212 37.9347V39.917H47.6443C45.8127 43.9165 42.6422 47.1687 38.7012 49.094C40.937 50.31 43.4949 51.0003 46.2106 51.0003C54.917 51.0003 62.0001 43.8975 62.0001 35.167H49.1001C48.9422 36.1138 48.7117 37.0385 48.4212 37.9347Z",
    fill: "#F3A521"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4209 37.9342C48.7146 37.038 48.9419 36.1165 49.0998 35.1665H48.4209V37.9342Z",
    fill: "#F38221"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7009 49.0933C42.6419 47.1712 45.8125 43.9158 47.6441 39.9163H43.9998V30.733H49.3683V19.333H46.2104C37.5041 19.333 30.4209 26.4358 30.4209 35.1663C30.4209 41.1735 33.7746 46.408 38.7009 49.0933Z",
    fill: "#F38221"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28714_730"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 38,
    fill: "white",
    transform: "translate(2 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeniAIcon);
export default __webpack_public_path__ + "static/media/GeniA_icon.c5d010e6384ba5dd2446c939e215086a.svg";
export { ForwardRef as ReactComponent };